<template>
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="$emit('closeModal')">
          <div class="row">
            <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
            <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
              <div class="modal-container" @click.stop>
  
                <div class="modal-header row" style="justify-content: flex-end;">
                  <!-- <div class="col-6">
                    <button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
                  </div> -->
                  <div class="col">
                    <button type="button" class="close" @click="$emit('closeModal')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
  
                <div class="modal-body">
                  <h2 class="title">Tambah {{ sparepart_type == 'P' ? 'Part' : 'Jasa' }}</h2>
                  <form>
                    <div class="row row-space">
                      <div class="col-md-6 offset-md-3">
                        <div class="input-group">
                          <label class="label">Sparepart Group<span style="color: red;">*</span></label>
                          <MultiSelect
                            v-if="options.sparepartAttachments"
                            v-model="form.sparepart_attachment_id"
                            :options="options.sparepartAttachments.map(x => x.id)"
                            :custom-label="opt => options.sparepartAttachments.find(x => x.id == opt).name"
                            :disabled="true"
                            placeholder="Pilih Sparepart Group"
                          ></MultiSelect>
                        </div>
                      </div>
                      <div class="col-md-6 offset-md-3">
                        <div class="input-group">
                          <label class="label">Sparepart Variant {{ sparepart_type == 'P' ? 'Part' : 'Jasa' }}<span style="color: red;">*</span></label>
                          <MultiSelect
                            v-if="sparepart_type == 'P' && options.sparepartVariants"
                            v-model="form.sparepart_variant_id"
                            :options="options.sparepartVariants.map(x => x.id)"
                            :custom-label="opt => options.sparepartVariants.find(x => x.id == opt).name"
                            placeholder="Pilih Sparepart"
                          ></MultiSelect>
                          <MultiSelect
                            v-if="sparepart_type == 'J' && options.sparepart"
                            v-model="form.sparepart_variant_id"
                            :options="options.sparepart.map(x => x.id)"
                            :custom-label="opt => options.sparepart.find(x => x.id == opt).sparepart_variants.name"
                            placeholder="Pilih Sparepart"
                          ></MultiSelect>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col mt-5" style="text-align: center">
                        <button type="button" class="btn btn-outline-danger" style="font-size:140%" @click="$emit('closeModal')">Kembali</button>
                        <button type="button" class="btn btn-primary ml-5" style="font-size:150%" @click="submitForm()">Tambah</button>
                      </div>
                    </div>
                  </form>
                </div>
            </div>
          </div>
        </div>
        <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
      </div>
    </div>
  </transition>
  </template>
  
  <script>
    import MultiSelect from 'vue-multiselect';
  
    export default {
      data () {
        return {
          options : {
            sparepartAttachments : [],
            sparepartVariants : [],
            sparepart : []
          },
          rangeConfig: {
            altInput: true,
            altInputClass: 'form-control input flatpickr-input w-100',
            animate: !this.isRTL()
          },
          form : {
            sparepart_attachment_id : '',
            sparepart_variant_id : '',
          }
        }
      },
      props : ['attachment_id', 'sparepart_type', 'attachment_list'],
      components:{
        MultiSelect,
      },
      mounted () {
        // this.getSparepartAttachments();
        this.getSparepart();
        this.options.sparepartAttachments = this.attachment_list;
        this.options.sparepartVariants = this.$store.getters.getSparepartVariant(this.sparepart_type);

        this.form.sparepart_attachment_id = this.attachment_id;
      },
      watch : {
        
      },
      methods : {
        getSparepartAttachments(){
          this.$http.get('/api/v1/sparepart-attachments')
          .then((resp)=>{
            this.options.sparepartAttachments = resp.data.data;
          })
          .catch((err)=>{console.log(err)})
        },
        getSparepart(){
          this.$http.get('/api/v1/masterData/sparepart?sparepart_type_id=1&pagination=false')
          .then((resp)=>{
            this.options.sparepart = resp.data.data;
          })
          .catch((err)=>{console.log(err)})
        },
        validateForm(){
          var valid = true;
          var error = [];
  
          if(this.form.sparepart_attachment_id == '' || this.form.sparepart_attachment_id == null){//Sparepart Group [Required]
            valid = false;
            error.push('Sparepart group wajib diisi');
          }
  
          if(this.form.sparepart_variant_id == '' || this.form.sparepart_variant_id == null){//Sparepart Variant Part/Jasa [Required]
            valid = false;
            error.push(`Sparepart variant ${ this.sparepart_type == 'P' ? 'part' : 'jasa' } wajib diisi`);
          }
  
          if(!valid) this.$store.dispatch('triggerAlert', [false, error]);
          else return valid;
        },
        async submitForm(){
          let vm = this;
          if(vm.validateForm()){

            let body = {
              sparepart_attachment_id : this.form.sparepart_attachment_id,
            }
            body[this.sparepart_type == 'J' ? 'sparepart_id' : 'sparepart_variant_id'] = this.form.sparepart_variant_id

            if (this.sparepart_type == 'J') {//JASA
              this.$http.post('/api/v1/attachment-services', body)
              .then((resp)=>{
                // alert(`Partshop ${vm.form.name} has been created`);
                this.$store.dispatch('triggerAlert', [true, [`Jasa telah berhasil ditambahkan`]]);
                this.$emit('updateTable');
                this.$emit('closeModal');
              })
              .catch((err)=>{
                console.log(err);
                if(err.response.data.data.nativeError.code == 'ER_DUP_ENTRY') {
                  this.$store.dispatch('triggerAlert', [false, ['Jasa terpilih telah ada di group ini']]);
                } else {
                  this.$store.dispatch('triggerAlert', [false, ['An Error has occured']]);
                }
              })
            } else {//PART
              this.$http.patch('/api/v1/sparepart-attachments/add-sparepart-variant', body)
              .then((resp)=>{
                // alert(`Partshop ${vm.form.name} has been created`);
                this.$store.dispatch('triggerAlert', [true, [`Part telah berhasil ditambahkan`]]);
                this.$emit('updateTable');
                this.$emit('closeModal');
              })
              .catch((err)=>{
                console.log(err);
                if(err.response.data.data.nativeError.code == 'ER_DUP_ENTRY') {
                  this.$store.dispatch('triggerAlert', [false, ['Part terpilih telah ada di group ini']]);
                } else {
                  this.$store.dispatch('triggerAlert', [false, ['An Error has occured']]);
                }
              })
            }

          }
        },
      }
    }
  </script>
  
  <style scoped>
  
  /* ==========================================================================
  #FORM made by Colorlib (https://colorlib.com)
  ========================================================================== */
  input {
    outline: none;
    margin: 0;
    border: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    width: 100%;
    font-size: 14px;
    font-family: inherit;
  }
  
  .input--style-4 {
    line-height: 50px;
    background: #fafafa;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    padding: 0 20px;
    font-size: 16px;
    color: #666;
    -webkit-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    transition: all 0.4s ease;
  }
  
  .input--style-4::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #666;
  }
  
  .input--style-4:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #666;
    opacity: 1;
  }
  
  .input--style-4::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #666;
    opacity: 1;
  }
  
  .input--style-4:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #666;
  }
  
  .input--style-4:-ms-input-placeholder {
    /* Microsoft Edge */
    color: #666;
  }
  
  .label {
    font-size: 16px;
    color: #555;
    text-transform: capitalize;
    display: block;
    margin-bottom: 5px;
  }
  
  .radio-container {
    display: inline-block;
    position: relative;
    padding-left: 30px;
    cursor: pointer;
    font-size: 16px;
    color: #666;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  
  .radio-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  
  .radio-container input:checked ~ .checkmark {
    background-color: #e5e5e5;
  }
  
  .radio-container input:checked ~ .checkmark:after {
    display: block;
  }
  
  .radio-container .checkmark:after {
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    background: #57b846;
  }
  
  .checkmark {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #e5e5e5;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  }
  
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  
  .input-group {
    position: relative;
    /* margin-bottom: 22px; */
    padding:20px;
  }
  
  .input-group-icon {
    position: relative;
  }
  
  .input-icon {
    position: absolute;
    font-size: 18px;
    color: #999;
    right: 18px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    cursor: pointer;
  }
  
  /* ==========================================================================
      #TITLE made by Colorlib (https://colorlib.com)
      ========================================================================== */
  .title {
    font-size: 40px;
    color: #525252;
    margin-bottom: 40px;
    text-align: center;
  }
  </style>
  